import { render } from "./valor.vue?vue&type=template&id=5c2b89ce&scoped=true"
import script from "./valor.vue?vue&type=script&lang=js"
export * from "./valor.vue?vue&type=script&lang=js"

import "./valor.vue?vue&type=style&index=0&id=5c2b89ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2b89ce"]])

export default __exports__